<template>
  <div class="cr-catalog">
    <div class="cr-container">
      <section class="cr-tabs">
        <div class="cr-tabs__button-wrapper">
          <ul class="cr-tabs__list">
            <li @click="setTabActive('catalog')" ref="catalog" class="cr-tabs__item" :class="{isActive: tabShow == 'catalog'}">
              <button class="cr-tabs__button js-button-tab" type="button">
                Разделы
              </button>
            </li>
            <li @click="setTabActive('brand')" ref="brand" class="cr-tabs__item" :class="{isActive: tabShow == 'brand'}">
              <button class="cr-tabs__button js-button-tab" type="button">
                Бренды
              </button>
            </li>
            <li class="cr-tabs__glide" :style="tabGlide"></li>
          </ul>
        </div>
        <div class="cr-tabs__body-wrapper">
          <div class="cr-tabs__body" :class="{isActive: tabShow == 'brand'}">
            <CatalogBrand></CatalogBrand>
          </div>
          <div class="cr-tabs__body" :class="{isActive: tabShow == 'catalog'}">
            <CatalogSection></CatalogSection>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import tab from "@/mixin/tab.vue";
import CatalogBrand from "@/views/components/CatalogBrand.vue";
import CatalogSection from "@/views/components/CatalogSection.vue";

export default {
  data: () => ({

  }),
  mixins: [tab],
  mounted() {

  },
  created() {
    this.$nextTick(() => {
      // Получаем сохраненную вкладку из localStorage
      const savedTab = localStorage.getItem('catalogActiveTab');
      // Если есть сохраненная вкладка, открываем её, иначе открываем 'brand' по умолчанию
      this.setTabActive(savedTab || 'catalog');
    });
  },
  computed: {

  },
  components: {CatalogBrand, CatalogSection},
  methods: {
    setTabActive(tab) {
      // Вызываем метод из миксина (если он там определен)
      if (this.$options.mixins[0].methods?.setTabActive) {
        this.$options.mixins[0].methods.setTabActive.call(this, tab);
      }

      // Сохраняем выбранную вкладку в localStorage
      localStorage.setItem('catalogActiveTab', tab);
    }
  },
}
</script>

